// utils/timeZones.js
import moment from 'moment-timezone';

/**
 * Certain legacy/alias zone names (e.g. "Canada/Eastern") throw
 * “Invalid Zone” errors on many servers.  We map those aliases to their
 * canonical IANA zone IDs but still show the alias label in the UI.
 */
const ALIAS_MAP = {
  'Canada/Eastern':     'America/Toronto',
  'Canada/Central':     'America/Winnipeg',
  'Canada/Mountain':    'America/Edmonton',
  'Canada/Pacific':     'America/Vancouver',
  'Canada/Newfoundland':'America/St_Johns',
  'Canada/Atlantic':    'America/Halifax',
  'Canada/Saskatchewan':'America/Regina',
};

/* -------------- Build the <Select> option list -------------- */

// 1) Start with every canonical zone **once**
const canonicalOptions = moment.tz
  .names()                                 // all names, incl. aliases
  .filter((tz) => !Object.keys(ALIAS_MAP).includes(tz)) // drop alias items
  .map((tz) => ({
    value: tz,                             // canonical value
    label: `${tz} (${moment.tz(tz).format('z')})`,
  }));

// 2) Add each alias as an *extra* option whose **value** is canonical
const aliasOptions = Object.entries(ALIAS_MAP).map(([alias, canonical]) => ({
  value: canonical,                        // what we store / send to BE
  label: `${alias} (${moment.tz(canonical).format('z')})`,
}));

// 3) Combine
const timeZones = [...canonicalOptions, ...aliasOptions];

export default timeZones;
